<template>
    <div class="container">
        <div class="row mb-5 d-flex justify-content-center">
            <div class="col-10 col-md-8 border rounded align-items-center justify-content-between p-3">
                <div class="row">
                    <div class="col-6">
                        <h5 class="text-nowrap font-weight-bold m-0" >About Page Content</h5>
                    </div>
                    <div class="col-6 text-right">
                        <b-spinner style="width: 17px; height: 17px" v-if="fetching" class="mr-2" small></b-spinner>
                        <icon-vue v-b-toggle.abt-page-content :icon="['far', 'edit']"
                                  class="pointer"></icon-vue>
                    </div>
                    <b-collapse visible ref="collapse" class="mt-3 col-12" id="abt-page-content">
                        <hr>
                        <div>
                            <b-form @submit.prevent="updateData(dbRefs.aboutRef, aboutContent)">
                                <b-form-group id="grp-title"
                                              label="Page Heading"
                                              label-for="input-title"
                                              description="This is text that appears atop the about page">
                                    <b-form-input
                                            id="input-title"
                                            v-model="aboutContent.title"
                                    ></b-form-input>
                                </b-form-group>
                                <b-form-group id="grp-subtitle"
                                              label="Page Sub-Heading"
                                              label-for="input-subtitle"
                                              description="This is text that appears below the heading">
                                    <b-form-input
                                            id="input-subtitle"
                                            v-model="aboutContent.subtitle"
                                    ></b-form-input>
                                </b-form-group>
                                <b-form-group id="grp-summary"
                                              label="Summary Text"
                                              label-for="input-summary">
                                    <b-form-textarea
                                            id="input-summary"
                                            v-model="aboutContent.summary"
                                            rows="6"
                                    ></b-form-textarea>
                                </b-form-group>
                                <b-form-group id="grp-body"
                                              label="Full About Text"
                                              label-for="input-body">
                                    <b-form-textarea
                                            id="input-body"
                                            v-model="aboutContent.body"
                                            rows="12"
                                    ></b-form-textarea>
                                </b-form-group>
                                <b-button class="btn-carnival px-5 py-1" type="submit" variant="outline-success" :disabled="saving">
                                    Save
                                </b-button>
                            </b-form>
                        </div>
                    </b-collapse>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
  import { EventBus } from '../../eventBus'
  import { defaultAboutContent } from '../../utils/content'
  import DataStreamListener from '../../mixins/dataListener'
  import AddDataHandler from '../../mixins/genericAddDataHandler'

  export default {
    data () {
      return {
        aboutContent: { ...defaultAboutContent },
      }
    },
    mixins: [DataStreamListener, AddDataHandler],
    async mounted () {
      this.fetchSingleData(this.dbRefs.aboutRef, defaultAboutContent)
      EventBus.$on('dataFetched', aboutContent => {
        this.aboutContent = aboutContent
        setTimeout(() => {
          this.fetching = false
        }, 1000)
      })
    }
  }
</script>